import {Injectable} from '@angular/core';
import {AccountResourceService} from '../../../shared/services/account-resource.service';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiConfig} from "../../../shared/services/api/config.api";

@Injectable()
export class HomeService {
  constructor(public httpClient: HttpClient,
              public account: AccountResourceService) {
  }

  getProfile(): any {
    return this.httpClient.get(ApiConfig.baseURL + 'api/profile/info', {headers: ApiConfig.requestOptionsHeader});
  }

  checkIfDeviceRegistered(token) {
    const checkDeviceUrl =
      ApiConfig.baseURL + "svc/eazypension-auth-service/v1/account/device";
    const headers = new HttpHeaders().append("Authorization", token);
    return this.httpClient.get(checkDeviceUrl, { headers: headers });
  }

  registerDevice(token) {
    const registerDeviceUrl =
      ApiConfig.baseURL +
      "svc/eazypension-auth-service/v1/account/device/register";
    const headers = new HttpHeaders().append("Authorization", token);
    return this.httpClient.post(registerDeviceUrl, {}, { headers: headers });
  }

}
